import type { ReactNode } from "react";
import styles from "./Stack.module.css";

type SpaceToken = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 12 | 14 | 16;

interface StackProps {
  readonly gap?: SpaceToken;
  readonly align?: "start" | "center" | "end" | "stretch";
  readonly children: ReactNode;
  readonly className?: string;
}

export function Stack({
  gap = 4,
  align = "stretch",
  children,
  className,
}: StackProps) {
  return (
    <div
      className={`${styles.stack} ${className ?? ""}`}
      style={{
        gap: `var(--space-${gap})`,
        alignItems: align === "stretch" ? "stretch" : `flex-${align === "center" ? "center" : align}`.replace("flex-center", "center"),
      }}
    >
      {children}
    </div>
  );
}
